module.exports = __webpack_public_path__ + "img/text_logo_black_horizontal_scaled.8e342a07.png";